const FORD_STORE_NAMES = [
  "airdrie",
  "olds",
  "redeer",
  "red deer",
  "canmore",
  "northvan",
  "north van",
  "richmond",
  "kamloop ford",
  "kamloops",
  "dearbornford",
  "dearborn ford",
  "santamonica",
  "santa monica",
  "evergreenford",
  "evergreen ford",
  "bison ford",
  "bisonford",
];

const normalizeStoreName = (name) =>
  (name ?? "").toLowerCase().trim().replace(/\s+/g, " ");

export const isFordStore = (store) => {
  const name = normalizeStoreName(store?.name);
  if (!name) return false;

  return FORD_STORE_NAMES.some((fordName) => {
    const normalizedFord = fordName.replace(/\s+/g, " ");
    const compactName = name.replace(/\s+/g, "");
    const compactFord = normalizedFord.replace(/\s+/g, "");
    return (
      name === normalizedFord ||
      name.includes(normalizedFord) ||
      compactName === compactFord ||
      compactName.includes(compactFord)
    );
  });
};

export const isKiaStore = (store) =>
  store?.name?.toLowerCase()?.includes("kia") ?? false;

export const getStoreScoreType = (store) => {
  if (isKiaStore(store)) return "kia";
  if (isFordStore(store)) return "ford";
  return "cei";
};
